import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/staff-group";

export const searchByPageStaffGroup = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getStaffGroupById = (serviceVatId) => axios.get(API_PATH + "/get-by-id/" + serviceVatId);

export const saveOrUpdateStaffGroup = serviceVat => axios.post(API_PATH + "/save-or-update", serviceVat);

export const deleteStaffGroup = serviceVatId => axios.delete(API_PATH + '/mark-delete/' + serviceVatId);

//export const saveStaffGroupSyncStaffGroupHRM = (searchObject) => axios.post(API_PATH + "/sync-employee-status-from-HRM", searchObject);